import { FONTS } from "../../constants/Fonts";
import { SIZES } from "../../constants/Sizes";
import { SPACING } from "../../constants/Spacing";
import { COLORS } from '../../constants/Colors';
import { BORDER } from "../../constants/Border";

const MOBILE = '@media (max-width: 768px)';

export const SX_STYLES = {
    container:{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imageStyle:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: "cover",
        width: '100%',
        height: '100%',
    },
    imageStyle1:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: "cover",
        width: '100%',
        height: '100%',
    },
    companyContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    companyName: {
        ...FONTS.font700,
        fontSize: SIZES._60px,
        color: COLORS.blueD66,
        marginBottom: '-1.5vh',
        [MOBILE]: { fontSize: '8vw', marginBottom: '-1vw' },
    },
    extensionName:  {
        ...FONTS.font700,
        fontSize: SIZES._60px,
        color: COLORS.blueD66,
        [MOBILE]: { fontSize: '8vw' },
    },
    section: {
        ...FONTS.font300,
        fontSize: SIZES._18px,
        color: COLORS.blueD66,
        marginBottom: '0.5vh',
        [MOBILE]: { fontSize: '3.5vw' },
    },
    section1: {
        ...FONTS.font300,
        fontSize: SIZES._20px,
        marginTop: '1.5vh',
        [MOBILE]: { fontSize: '3.5vw', textAlign: 'center', paddingLeft: '4vw', paddingRight: '4vw' },
    },
    buttonContact1: { 
        ...FONTS.font400,
        fontSize: SIZES._18px,
        color: COLORS.white,
        backgroundColor: COLORS.blueE7,
        textTransform:'none',
        paddingTop: SPACING._16px,
        paddingBottom: SPACING._16px,
        paddingRight: SPACING._28px,
        paddingLeft: SPACING._28px,
        borderRadius: BORDER._8px,
        marginTop: SPACING._48px,
        transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease',
        '&:hover': {
            backgroundColor: COLORS.blueD4,
            transform: 'translateY(-3px)',
            boxShadow: '0 8px 24px rgba(41,97,231,0.32)',
        },
        '&:active': {
            transform: 'translateY(0px)',
        },
    },
    section2: {
        ...FONTS.font400,
        fontSize: SIZES._16px,
        color: COLORS.gray85,
        marginBottom: SPACING._32px,
        [MOBILE]: { fontSize: '3.5vw', textAlign: 'center' },
    },
    logoPartnersContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        paddingLeft: SPACING.x_large,
        paddingRight: SPACING.x_large,
        paddingTop: SPACING._96px,
        paddingBottom: SPACING._96px,
        [MOBILE]: { paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '8vw', paddingBottom: '8vw' },
    },
    logoRowContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: SPACING._32px,
        [MOBILE]: { gap: '5vw' },
    },
    logoPartnersWrapper: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: '4.6vw',
        flexWrap: 'wrap',
    },
    section2Container:{
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute', 
        marginLeft: SPACING.x_large,  
        gap: SPACING._12px,
        [MOBILE]: { marginLeft: '4vw', marginRight: '4vw' },
    },
    section2Label: {
        ...FONTS.font500,
        fontSize: SIZES._16px,
        color: COLORS.blueD66,
        [MOBILE]: { fontSize: '3.5vw' },
    },
    section2title: {
        ...FONTS.font600,
        fontSize: SIZES._36px,
        color: COLORS.blueD66,
        [MOBILE]: { fontSize: '5.5vw' },
    },
    section2body: {
        ...FONTS.font300,
        fontSize: SIZES._20px,
        marginTop: SPACING._8px,
        [MOBILE]: { fontSize: '3.5vw', display: 'none' },
    },
    btnReadContainer: {
        marginTop: SPACING._40px
    },
    section2Image: {
        zIndex: -1, 
        width: '100%'
    },
    productsOfferedContainer: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: SPACING._96px,
        paddingBottom: SPACING._64px,
        paddingLeft: SPACING.x_large,
        paddingRight: SPACING.x_large,
        [MOBILE]: { paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '8vw', paddingBottom: '4vw' },
    },
    productsOfferedWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [MOBILE]: { flexDirection: 'column', alignItems: 'flex-start', gap: '3vw' },
    },
    sectionLabel: {
        ...FONTS.font500,
        fontSize: SIZES._36px,
        [MOBILE]: { fontSize: '6vw' },
    },
    sectionSubLabel:{
        ...FONTS.font300,
        fontSize: SIZES._20px,
        color: COLORS.gray85,
        [MOBILE]: { fontSize: '3.5vw' },
    },
    listProductsContainer: {
        display: 'flex', 
        flexWrap: 'nowrap', 
        overflow: 'hidden',
        scrollBehavior: 'smooth',
        gap: SPACING._32px
    },
    paginationContainer: {
        display: 'flex', 
        marginLeft: SPACING.x_large, 
        gap: SPACING._32px,
        marginTop: SPACING._32px,
        [MOBILE]: { marginLeft: '4vw' },
    },
    pagination: {
        borderColor: COLORS.grayEA, 
        borderRadius: 100,
        paddingTop: SPACING._16px, 
        paddingBottom: SPACING._16px,
        width: '2.8vw',
        minWidth: 0,
        [MOBILE]: { width: '10vw' },
    },
    paginationArrow: {
        color: COLORS.gray85,
        fontSize: SIZES._24px,
    },
    servicesContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: SPACING._8px,
        paddingTop: SPACING._96px,
        paddingLeft: SPACING.x_large,
        paddingRight: SPACING.x_large,
        paddingBottom: SPACING._160px,
        marginTop: SPACING._96px,
        background: COLORS.lightGrayFB,
        [MOBILE]: { paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '8vw', paddingBottom: '8vw', marginTop: '4vw' },
    },
    servicesSectionContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: SPACING._20px
    },
    hospitalsContainer: {
        display: 'flex', 
        flexDirection: 'column',
        gap: SPACING._48px,
        [MOBILE]: { width: '100%' },
    },
    logoImg: {
        maxWidth: '100%',
        objectFit: 'contain',
        '@media (max-width: 768px)': {
            height: '7vw !important',
            width: 'auto !important',
        },
    },
    awardContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        paddingTop: SPACING._96px, 
        paddingRight: SPACING._96px, 
        paddingLeft: SPACING._96px, 
        paddingBottom: SPACING._96px,
        [MOBILE]: { paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '8vw', paddingBottom: '8vw' },
    },
    award: {
        ...FONTS.font500,
        fontSize: SIZES._60px,
        [MOBILE]: { fontSize: '7vw', textAlign: 'center' },
    },
    awardDescription: {
        ...FONTS.font300,
        fontSize: SIZES._20px,
        color: COLORS.gray85,
        textAlign: 'center', 
        marginTop: SPACING._24px,
        marginBottom: SPACING._96px,
        [MOBILE]: { fontSize: '3.5vw', marginBottom: '6vw' },
    },
}